import React, { Component } from 'react';
import {
  TextInput,
  LinkButton,
  Text,
  YearMonthRangePopover,
  NotificationMessage,
} from 'bench-internal-theme';
import { toDate, getLastDateOfMonth, getISODateString } from 'date-functions';
import env from 'bench-environment';
import styled from 'styled-components';

const FormLayout = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: max-content 252px max-content 252px max-content;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  margin: 16px 0;

  ${NotificationMessage} {
    grid-column: span 6;
  }

  input[readonly] {
    cursor: pointer;
  }
`;

/**
 * Allows user to download a client's general ledger for the provided year-month range
 * @param {Object} props
 * @param {ID} props.clientId
 * @param {string} props.startYearMonth - Start year-month of ledger in YYYY-MM format
 * @param {string} props.endYearMonth - End year-month of ledger in YYYY-MM format
 */
class DownloadGeneralLedger extends Component<
  { clientId: string; startYearMonth: string; endYearMonth: string },
  { startYearMonth: string; endYearMonth: string }
> {
  static defaultProps = {
    startYearMonth: '',
    endYearMonth: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      startYearMonth: props.startYearMonth,
      endYearMonth: props.endYearMonth,
    };
  }

  handleStartYearMonthSelect = startYearMonth => {
    this.setState({ startYearMonth });
  };

  handleEndYearMonthSelect = endYearMonth => {
    this.setState({ endYearMonth });
  };

  render() {
    const { clientId } = this.props;
    const { startYearMonth, endYearMonth } = this.state;
    const startDate = toDate(startYearMonth);
    const endDate = toDate(endYearMonth);

    const startDateGL = getISODateString(startDate);
    const endDateGL = getISODateString(getLastDateOfMonth(endDate));

    const openInAppGeneralLedgerURL = `${env.location.bkTools}/${clientId}/general-ledger?startDate=${startDateGL}&endDate=${endDateGL}`;

    const isStartDateAfterEndDate = startDate > endDate;

    return (
      <FormLayout>
        <Text uppercase>From</Text>
        <YearMonthRangePopover
          defaultDisplayedYear={startDate.getFullYear()}
          defaultStartYearMonth={startYearMonth}
          onRangeSelect={this.handleStartYearMonthSelect}
          selectionType="single"
        >
          {togglePopover => <TextInput onClick={togglePopover} readOnly value={startYearMonth} />}
        </YearMonthRangePopover>
        <Text uppercase>To</Text>
        <YearMonthRangePopover
          defaultDisplayedYear={endDate.getFullYear()}
          defaultStartYearMonth={endYearMonth}
          onRangeSelect={this.handleEndYearMonthSelect}
          selectionType="single"
        >
          {togglePopover => <TextInput onClick={togglePopover} readOnly value={endYearMonth} />}
        </YearMonthRangePopover>
        <LinkButton
          data-heap-id="review-tool-open-general-ledger-in-app"
          disabled={isStartDateAfterEndDate}
          href={openInAppGeneralLedgerURL}
          size="small"
          styleType="primary"
          target="_blank"
        >
          Open General Ledger In-App
        </LinkButton>
        {isStartDateAfterEndDate && (
          <NotificationMessage styleType="error">
            The selected “to” date is before the “from” date
          </NotificationMessage>
        )}
      </FormLayout>
    );
  }
}

export default DownloadGeneralLedger;
